import {
  collection,
  doc,
  getDoc,
  increment,
  setDoc,
  updateDoc,
} from "firebase/firestore";
import { db } from "..";
import { Blog_Type } from "../../model";

const collection_name = "blogs";

export const blogCollectionRef = collection(db, collection_name);

export const getBlog = async (id: string) => {
  try {
    const docRef = doc(db, collection_name, id);

    const docSnap = await getDoc(docRef);

    return docSnap.data() as Blog_Type;
  } catch (error) {
    console.log(error);
  }
};

export const setBlogData = async (blog: Blog_Type) => {
  try {
    await setDoc(doc(blogCollectionRef, blog.id), blog);
  } catch (error) {
    console.log("Error in setBlogData", error);
  }
};

export const setReadBlog = async (id: string) => {
  try {
    const docRef = doc(db, collection_name, id);
    const docData = await getDoc(docRef);

    if (docData.exists()) {
      const blog = docData.data() as Blog_Type;

      if (blog.numberOfReads) {
        await updateDoc(docRef, {
          numberOfReads: increment(1),
        });
      } else {
        await updateDoc(docRef, {
          numberOfReads: 1,
        });
      }
    }
  } catch (error) {
    console.log(error);
  }
};
